const useCurrentOrganization = () => {
  const id = localStorage.getItem('currentOrganizationId');
  const name = localStorage.getItem('organizationName');

  return {
    id,
    name,
  };
};

export default useCurrentOrganization;
